import {TENANT_NO_STORAGE_RESIDENCY_REGION} from 'definitions/tenantConfig'
import {useTenantConfigQuery} from 'hooks/useTenantConfigQuery'

interface UseTenantResidencyReturn {
  /** Tenant config resolved and the tenant keeps no records. */
  isNoStorageTenant: boolean
  /** Tenant config resolved and the tenant stores records in a region. */
  isStorageTenant: boolean
  /** Tenant config has not resolved yet, so residency is still unknown. */
  isResidencyPending: boolean
}

/**
 * @description Data residency of the current tenant, for gating surfaces that
 * need stored records (Analytics views, the Subscription storage panel).
 */
export const useTenantResidency = (): UseTenantResidencyReturn => {
  const {data, isSuccess, isLoading, isFetching} = useTenantConfigQuery()
  const isNoStorageTenant =
    isSuccess &&
    data?.data?.residencyRegion === TENANT_NO_STORAGE_RESIDENCY_REGION

  return {
    isNoStorageTenant,
    isStorageTenant: isSuccess && !isNoStorageTenant,
    isResidencyPending: !isSuccess && (isLoading || isFetching),
  }
}
